'use strict';

(function($){
  var app = {

    init: function() {
      this.megaMenu();
      this.search();
      this.stickyMenu();
      this.counter();
      this.cookiesAccept();
      this.cookiesConfig();
      this.lazyframe();
      this.btnAnchor();
      this.videoSlider();
	  this.slickSlider();
      this.menuCorporate();
      this.menuComunication();
      this.menuPersonas();
      this.menuReferences();
      this.prepareLateralMenu();
      this.carouselFullscreen();
      this.sectorsContacts();
      this.customFile();
      this.formCompliance();
      this.sameHeightOffers();
      this.paginationOffers();
      return false;
    },
    megaMenu: function () {
     $('.toggle-menu').click(function(){
      $('.exo-menu').toggleClass('display');
     });
    },
    search: function () {
      $("span.search-button").click(function(){
        $(".search-wrapper").css("bottom", "0px");
        $("button.close-search").css("display", "block");
      });
      $("button.close-search").click(function(){
        $(".search-wrapper").css("bottom", "-2000px");
        $("button.close-search").css("display", "none");
      });
    },
    stickyMenu: function () {
       if(typeof $('.sidebar-nav').html() !== 'undefined'){
         // grab the initial top offset of the navigation
         var stickyNavTop = $('.sidebar-nav').offset().top;

         // our function that decides weather the navigation bar should have "fixed" css position or not.
         var stickyNav = function(){
           var scrollTop = $(window).scrollTop(); // our current vertical position from the top

           // if we've scrolled more than the navigation, change its position to fixed to stick to top,
           // otherwise change it back to relative
           if (scrollTop > stickyNavTop) {
             $('.sidebar-nav').addClass('sticky');
           } else {
             $('.sidebar-nav').removeClass('sticky');
           }
         };
         stickyNav();
         // and run it again every time you scroll
         $(window).scroll(function() {
           stickyNav();
         });
       }
    },
    cookiesAccept: function () {
      var msgCookies = $('#cookies-msg');
      var btnAccept = $('.btn-cookies-accept');
      btnAccept.click(function (e){
        e.preventDefault();
        $.cookie(keyAnalyticCookies, '1', { expires: 7, path: '/' });
        $.cookie(keyMarketingCookies, '1', { expires: 7, path: '/' });
        $.cookie(keyRrssCookies, '1', { expires: 7, path: '/' });
        msgCookies.slideUp();
      })
    },
    counter: function (){
        $('.counter').each(function () {
          $(this).prop('Counter',0).animate({
              Counter: $(this).text()
          }, {
              duration: 4000,
              easing: 'swing',
              step: function (now) {
                  $(this).text(Math.ceil(now));
              }
          });
        });
      },
    cookiesConfig: function (){
      var configContainer = $('.cookies-configuration-block');
      var msgCookies = $('#cookies-msg');

      if(typeof configContainer.html() !== 'undefined')
      {
        var checkAll = configContainer.find('input#cookies-todas');
        var checkAnalytics = configContainer.find('input#cookies-analiticas');
        var checkMarketing = configContainer.find('input#cookies-marketing');
        var checkRrss = configContainer.find('input#cookies-rrss');
        var buttonSave = configContainer.find('.btn-save-config');
        var msgSuccess = configContainer.find('#text-success');
        var msgError = configContainer.find('#text-error');

        checkAll.click(function ()
        {
          if($(this).prop('checked'))
          {
            checkAnalytics.prop('checked',true);
            checkMarketing.prop('checked',true);
            checkRrss.prop('checked',true);
          }
          else
          {
            checkAnalytics.prop('checked',false);
            checkMarketing.prop('checked',false);
            checkRrss.prop('checked',false);
          }
        })
        buttonSave.click(function ()
        {
          msgSuccess.addClass('d-none');
          msgError.addClass('d-none');
          $.cookie(keyAnalyticCookies, ((checkAnalytics.prop('checked')) ? '1' : '0'), { expires: 7, path: '/' });
          $.cookie(keyMarketingCookies, ((checkMarketing.prop('checked')) ? '1' : '0'), { expires: 7, path: '/' });
          $.cookie(keyRrssCookies, ((checkRrss.prop('checked')) ? '1' : '0'), { expires: 7, path: '/' });
          if(typeof msgCookies.html() !== 'undefined') msgCookies.hide();
          msgSuccess.removeClass('d-none');
        })
      }
    },
    lazyframe: function () {
      lazyframe('.lazyframe', {
        apikey: 'AIzaSyBG22hzTpV5lxNFeYgNDuv1SSD_NBEAu9k', // cambiar esta API por la del proyecto https://github.com/vb/lazyframe#apikey
        debounce: 250,

        onAppend: (function (lazyframe) {
          return console.log(lazyframe.parentNode.classList.add("loaded"))
        })
      });
    },
    controlButtonAnchor : function (caller,target) {
      var position = $(window).scrollTop();
      var height = $(window).height();
      var bottom = position + height;
      var targetTop = target.position().top;

      if(bottom >= targetTop) caller.hide();
      else caller.show();

    },
    btnAnchor : function () {
      $(document).ready(function ()
      {
        var btnAnchor = $('.btn-anchor');
        if(typeof btnAnchor.html() !== 'undefined') {
          var target = $(btnAnchor.attr('href'));
          var sectionTarget = target.closest('.form-bottom');
          btnAnchor.click(function (e){
            e.preventDefault();
            sectionTarget.addClass('modal-type');
            $('body').addClass('blocked');
          })
          sectionTarget.find('.close').click(function (e){
            e.preventDefault();
            sectionTarget.removeClass('modal-type');
            $('body').removeClass('blocked');
          })
          app.controlButtonAnchor(btnAnchor,sectionTarget);
          $(window).scroll(function (){
              app.controlButtonAnchor(btnAnchor,sectionTarget);
          })
          $(window).resize(function (){
              app.controlButtonAnchor(btnAnchor,sectionTarget);
          })
        }
      })
    },
    videoSlider : function ()
    {
      var carousel = $('.video-carousel');
      if(typeof carousel.html() !== 'undefined')
      {
        carousel.on('ready.flickity',function (){
          setTimeout(function ()
          {
            if(typeof carousel.find('.is-selected').find('iframe').html() !== 'undefined')
            {
              carousel.find('.is-selected').find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            }
          },1000)
        })
        var $flickity = carousel.flickity({ "lazyLoad": 1, "pageDots": false, "adaptiveHeight": true });
        $flickity.on('selected.flickity',function (e,i){
          carousel.find('iframe').each(function (){
            var obj = $(this);
            if($(this).parent().parent().hasClass('is-selected'))
            {
              obj[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            }
            else
            {
              obj[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            }
          })
        })
      }
    },
		slickSlider: function(){
			$(".slick").slick()
		},
    menuCorporate : function ()
    {
      var navCorporative = $('.nav-corporative');
      var subNavCorporative = $('.nav-corporative').children('ul');
      if(typeof subNavCorporative.html() !== 'undefined')
      {
        //Colocamos la capa submenu
        var hNav = navCorporative.outerHeight();
        subNavCorporative.css({top : hNav + 'px'})

        //Mostramos ocultamos segun corresponda
        navCorporative.mouseenter(function ()
        {
          subNavCorporative.stop(true,false).slideDown(150);
        }).mouseleave(function (){
          subNavCorporative.stop(true,false).slideUp(150);
        })
      }
    },
    menuComunication : function ()
    {
      var navComunication = $('.nav-comunication');
      var subNavComunication = $('.nav-comunication').children('ul');
      if(typeof subNavComunication.html() !== 'undefined')
      {
        //Colocamos la capa submenu
        var hNav = navComunication.outerHeight();
        subNavComunication.css({top : hNav + 'px'})

        //Mostramos ocultamos segun corresponda
        navComunication.mouseenter(function ()
        {
          subNavComunication.stop(true,false).slideDown(150);
        }).mouseleave(function (){
          subNavComunication.stop(true,false).slideUp(150);
        })
      }
    },
    menuPersonas : function ()
    {
      var navPeople = $('.nav-personas');
      var subNavPeople = $('.nav-personas').children('ul');
      if(typeof subNavPeople.html() !== 'undefined')
      {
        //Colocamos la capa submenu
        var hNav = navPeople.outerHeight();
        subNavPeople.css({top : hNav + 'px'})

        //Mostramos ocultamos segun corresponda
        navPeople.mouseenter(function ()
        {
          subNavPeople.stop(true,false).slideDown(150);
        }).mouseleave(function (){
          subNavPeople.stop(true,false).slideUp(150);
        })
      }
    },
    cleanActivesMenuReferences : function (links){
      links.each(function (){
        $(this).parent().removeClass('active');
      })
    },
    changeActiveMenuReferences : function (menu,caller)
    {
      var menuLinks = menu.find('a');
      if(caller === undefined)
      {
        if(window.location.hash !== ''){
          var anchor = window.location.hash;
          this.cleanActivesMenuReferences(menuLinks);
          menu.find('a[href$="' + anchor + '"]').parent().addClass('active');
        }
      }
      else {
        this.cleanActivesMenuReferences(menuLinks);
        caller.parent().addClass('active');
      }
    },
    menuReferences : function () {
      var menu = $('#aside-references');
      if(typeof menu.html() !== 'undefined') {
        this.changeActiveMenuReferences(menu);
        menu.find('a').on('click',function (){
          app.changeActiveMenuReferences(menu,$(this));
        })
      }
    },
    controleOversize : function(sidebar,list){
      var sidebarHeight = sidebar.height();
      var listHeight = list.height();

      if(listHeight > sidebarHeight) sidebar.addClass('oversized');
      else sidebar.removeClass('oversized');
    },
    prepareLateralMenu : function () {
      var btnSidebar = $('#sidebar-btn');
      var sidebar = $('#sidebar');
      var list = $('#sidebar > ul');
      this.controleOversize(sidebar,list);
      btnSidebar.click(function(){
        $('#sidebar').toggleClass('visible');
      });
      $(window).resize(function () {
        app.controleOversize(sidebar,list);
      })
    },
    carouselFullscreen : function () {
      var options =  { groupCells: false, fullscreen: true, lazyLoad: 1, cellAlign: "left", contain: true };
      $('.carousel-fullscreen').each(function() {
        var carousel = $(this).flickity(options);
        carousel.find('img').click(function () {
          var index = $(this).closest('.carousel-cell').index();
          carousel.flickity('select',index);
          carousel.flickity('viewFullscreen');
        })
      })

    },
    sectorsContacts : function () {
      var commercialsContainer = $('.commercials');
      var btnsDeploy = commercialsContainer.find('.btn-deploy');
      var commercialsItems = commercialsContainer.find('.commercials-sector');
      btnsDeploy.click(function (e) {
        e.preventDefault();
        if(!$(this).hasClass('active')) {
          btnsDeploy.removeClass('active');
          $(this).addClass('active');
          commercialsItems.removeClass('active');
          $($(this).attr('href')).addClass('active');
        }
      })
    },
    customFile : function () {
      $('.custom-file-input').change(function (){
        if($(this).val() !== '') {
          let value = $(this).val();
          if(value.indexOf('fakepath') !== -1) {
            value = value.split('\\').pop();
          }
          $(`label[for="${$(this).attr('id')}"]`).html(value);
        }
      })
    },
    formCompliance : function () {
      let form = $('.form-bottom-compliance'),
          inputName = form.find('input#nombre'),
          inputPhone = form.find('input#telefono'),
          inputEmail = form.find('input#email'),
          inputAnonymous = form.find('.input-anonymous');
      inputAnonymous.click(function () {
        if($(this).prop('checked')) {
          inputName.attr('placeholder',inputName.attr('placeholder').replace(' *', ''));
          inputPhone.attr('placeholder',inputPhone.attr('placeholder').replace(' *', ''));
          inputEmail.attr('placeholder',inputEmail.attr('placeholder').replace(' *', ''));
          inputName.removeAttr('data-validation');
          inputName.removeAttr('data-validation-event');
          inputPhone.removeAttr('data-validation');
          inputPhone.removeAttr('data-validation-event');
          inputEmail.removeAttr('data-validation');
          inputEmail.removeAttr('data-validation-event');
        } else {
          if(inputName.attr('placeholder').indexOf(' *') === -1) inputName.attr('placeholder',inputName.attr('placeholder') + ' *');
          if(inputPhone.attr('placeholder').indexOf(' *') === -1) inputPhone.attr('placeholder',inputPhone.attr('placeholder') + ' *');
          if(inputEmail.attr('placeholder').indexOf(' *') === -1) inputEmail.attr('placeholder',inputEmail.attr('placeholder') + ' *');
          inputName.attr('data-validation','required');
          inputName.attr('data-validation-event','blur');
          inputPhone.attr('data-validation','required');
          inputPhone.attr('data-validation-event','blur');
          inputEmail.attr('data-validation','required email');
          inputEmail.attr('data-validation-event','blur');
        }
      })
    },
    sameHeightOffers: function () {
      let offers = $('.oportunidades').find('.convocatoria');
      if(offers.length > 0) {
        let hMax = 0;
        offers.each(function (){
          let h = $(this).height();
          if(h > hMax) hMax = h;
        })
        if(hMax > 0) offers.css('height',hMax + 'px');
      }
    },
    paginationOffers : function () {
      let btnPagination = $('.btn-pagination-offers'),
          loading = btnPagination.parent().children('.loading');
      if(typeof btnPagination.html() !== 'undefined') {
        btnPagination.click(function (e) {
          e.preventDefault();
          btnPagination.prop('disabled',true);
          let next = parseInt($(this).data('pag')) + 1,
              max = $(this).data('max');
          loading.removeClass('d-none');
          $.ajax({
            url: site_url + '/ajax_offers_pagination',
            method: 'post',
            dataType: 'json',
            data: {pag: next},
            success : function(data) {
              if(data.noData) {
                btnPagination.remove();
              } else {
                let html = '';
                for (let d in data) {
                  html += `
                    <div class="col-12 col-md-6 convocatoria mb-4">
                        <div class="box">
                            <div class="box-txt">
                                <p class="font-bold poppins${(typeof data[d].centro !== "undefined" && data[d].centro !== '') ? ' mb-0' : ''}">${data[d].titulo_l}</p>
                                ${(typeof data[d].centro !== "undefined" && data[d].centro !== '') ? `<p class="font-semibold poppins">${data[d].centro}</p>` : ''}
                                <div class="info-list-offer">${data[d].texto}</div>
                                ${(typeof data[d].link !== 'undefined' && data[d].link !== '') ? `<a href="${data[d].link}" class="show-more"><span>+</span>${data[d].more_info}</a>` : ''}
                            </div>
                        </div>
                    </div>
                  `;
                }
                btnPagination.data('pag',next);
                btnPagination.attr('data-pag',next);
                btnPagination.parent().before(html);
                app.sameHeightOffers();
              }
              let numberOfOffers = $('.oportunidades').find('.convocatoria').length;
              if(numberOfOffers >= max) btnPagination.remove();
              else btnPagination.prop('disabled',false);
              loading.addClass('d-none');
            }
          })
        })
      }
    }
  };
  $(function(){
    $(document).ready(function() {
      "use strict";
      $('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
      $('.menu > ul > li > ul:not(:has(ul))').addClass('normal-sub');
      $(".menu > ul").before("<a href=\"#\" class=\"menu-mobile\">&nbsp;</a>");
      if ($(window).width() > 1199) {
        $(".menu > ul > li").hover(function(e) {
          var visible = $(this).children("ul").is(':visible');
          if(!visible)
          {
            var thisChildrenHtml = $(this).children("ul").html();
            $('.normal-sub').each(function ()
            {
              if($(this).html() !== thisChildrenHtml) $(this).slideUp(150);
            })
            $(this).children("ul").stop(true,false).slideDown(150);
          }
          else
          {
            $(this).children("ul").stop(true,false).slideUp(150);
          }
        });
      }
      if ($(window).width() <= 1199) {
        $(".menu > ul > li").click(function() {
            $(this).children("ul").fadeToggle(150);
        });
      }
      $(".menu-mobile").click(function(e) {
				$('body').toggleClass('menu--opened')
        $(".menu > ul").toggleClass('show-on-mobile');
        e.preventDefault();
      });
    });
    $(window).resize(function() {
      $(".menu > ul > li").children("ul").hide();
			$('body').removeClass('menu--opened')
      $(".menu > ul").removeClass('show-on-mobile');
    });

    $(".show").flickity({
      wrapAround: true,
      //pageDots: false
    });

    function nextPrev(slider, btn, wrapped) {
      $(btn).on('click', function(e) {
        e.preventDefault();

        var dir = $(this).attr('data-direction');
        slider.flickity(dir, wrapped, false);
      })
    }
    var $navBtn = $('.carousel-nav__button');
    function updateNav(el) {
      $navBtn.removeClass('carousel-nav__button--is-active');
      el.addClass('carousel-nav__button--is-active');
    }
    function disableInactiveBtns() {
      var flkty = $carousel.data('flickity');

      if (typeof flkty !== 'undefined' && flkty.selectedIndex === 0) {
        $('.carousel-btn--prev').prop('disabled', true);
      } else {
        $('.carousel-btn--prev').prop('disabled', false);
      }

      if (typeof flkty !== 'undefined' && flkty.selectedIndex === flkty.cells.length - 1) {
        $('.carousel-btn--next').prop('disabled', true);
      } else {
        $('.carousel-btn--next').prop('disabled', false);
      }
    }
    if(typeof $('.historia-carousel').html() !== 'undefined')
    {
      //Da errores y parece que no aporta
      // create default carousel options
      var flkOptions = {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        dragThreshold: 10,
        wrapAround: true,
      }
      // init carousel
      var $carousel = $('.historia-carousel .carousel').flickity(flkOptions);
      // Custom next/prev arrows
      var $btnOne = $('.historia-carousel .carousel-btn')
      nextPrev($carousel, $btnOne, false);
      $navBtn.on('click', function(e) {
        e.preventDefault();
        updateNav($(this));
        var active = $('.carousel-nav .carousel-nav__button--is-active').index();
        $carousel.flickity( 'select', active)
      })
      $carousel.on('select.flickity', function(){
        var index = $carousel.data('flickity').selectedIndex;
        var active = $('.carousel-nav .carousel-nav__button').eq(index);
        updateNav(active);
        disableInactiveBtns();
      })
      disableInactiveBtns()
    }

    app.init()
  });
})(jQuery);